import type { SelectFieldChoices } from '@Types/GF/Fields';

type SelectType = {
	placeholder?: string;
	name: string;
	id: string;
	autoComplete?: string;
	required: boolean;
	label: string;
	onChange: React.ChangeEventHandler<HTMLSelectElement>;
	htmlFor: string;
	ariaLabel: string;
	disabled?: boolean;
	className?: string;
	description?: string | null;
	choices: SelectFieldChoices[];
};

export default function Select(props: SelectType) {
	const {
		placeholder,
		name,
		id,
		autoComplete,
		required,
		label,
		htmlFor,
		onChange,
		ariaLabel,
		disabled = false,
		className = '',
		description,
		choices,
	} = props;

	const inputTypeModel = {
		id: id,

		name: name,
		autoComplete: autoComplete,
		required: required,
		onChange: onChange,
		'aria-label': ariaLabel,
		disabled: disabled,
		className: className,
	};
	return (
		<div className={`relative h-12 w-full ${description ? 'mb-10' : 'mb-5'}`}>
			<select
				{...inputTypeModel}
				className={`peer relative size-full appearance-none rounded-minos-form-input border-2 border-minos-form-input-border-color bg-minos-form-input-bg-color px-4 text-base text-minos-form-input-color outline outline-0 transition-all focus:border-2 focus:border-minos-form-secondary-color focus:outline-0 disabled:cursor-not-allowed disabled:bg-minos-blue_dark-100 ${className}`}
			>
				{placeholder && <option className='text-base text-minos-blue_dark-200'>{placeholder}</option>}
				{choices?.map((choice) => (
					<>
						<option className='p-2 text-base' key={choice?.value || ''} value={choice?.value || ''}>
							{choice?.text || ''}
						</option>
					</>
				))}
			</select>
			<label
				htmlFor={htmlFor}
				className={`pointer-events-none absolute -top-3.5 left-4 !overflow-visible truncate rounded-md bg-minos-form-input-bg-color px-1.5 py-1 !text-[11px] text-base leading-tight text-minos-form-input-color transition-all peer-focus:rounded-md peer-focus:bg-minos-form-input-bg-color peer-focus:px-1.5 peer-focus:py-1 peer-focus:text-[11px] peer-focus:font-semibold peer-focus:leading-tight peer-focus:text-minos-form-secondary-color peer-disabled:text-transparent ${
					required &&
					'after:ml-0.5 after:font-semibold after:text-minos-form-require-color after:content-["*"] '
				}`}
			>
				{label}
			</label>
			{description ? <p className='mt-1 text-sm'>{description}</p> : null}
		</div>
	);
}
